import { render, staticRenderFns } from "./pretrade.vue?vue&type=template&id=5dfcf0fc&lang=pug"
import script from "./pretrade.vue?vue&type=script&lang=js"
export * from "./pretrade.vue?vue&type=script&lang=js"
import style0 from "./pretrade.vue?vue&type=style&index=0&id=5dfcf0fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports